/** @ignore */
export var hiddenStyleList = "\n  display: none !important;\n  width: 1px !important;\n  height: 1px !important;\n  position: fixed !important;\n  z-index: -99 !important;\n  bottom: 0px !important;\n  right: 0px !important;\n";
/** @ignore */
export var protocol = 'aspera://';
/** @ignore */
export var baseInstallerUrl = 'https://downloads.ibmaspera.com/downloads/desktop';
/** @ignore */
export var installerUrl = "".concat(baseInstallerUrl, "/latest/stable");
